<template>
    <div style="display:inline">
        <select name="city_id" v-model="city_id" :class="ele_class" ref = "city_id_ref">
            <option value="">{{ translations.choose_city }}</option>
            <option v-if="disable_all_option != 'true'" value="">{{ translations.all_cities }}</option>
            <option v-for="city in cities" :key="city.id" :value="city.id">{{city.name}}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props:['get_cities_url' , 'option_null' , 'ele_class', 'init_city_id', 'disable_all_option'],
        data() {
            return {
                cities: {},
                city_id: "",
                lang: window.current_locale
            };
        },
        computed: {
            translations() {
                const translations = {
                    ar: {
                        choose_city: 'اختر المدينة',
                        all_cities: 'كل المدن'
                    },
                    en: {
                        choose_city: 'Choose City',
                        all_cities: 'All Cities'
                    }
                };
                
                return translations[this.lang] || translations.ar;
            }
        },
        methods: {
            get_cities(country_id){
                axios.get(this.get_cities_url , {params: { country_id: country_id, lang: this.lang }}).then((response) => (this.cities = response.data));
            }
        },
        mounted() {
            
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const country_id_url = urlParams.get('country_id');
            const city_id_url = urlParams.get('city_id');
            if(country_id_url != null){
                this.get_cities(country_id_url);
            }
            if(city_id_url != null){
                this.city_id = city_id_url
            }
            if(this.init_city_id){
                this.city_id = this.init_city_id
                this.get_cities(this.$parent.$refs.countries_component_ref.country_id);
            }
        },
    };
</script>